// 9fbef606107a605d69c0edbcd8029e5d
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import FeaturedProductTile from '@tcp/core/src/components/common/molecules/FeaturedProductTile/views/FeaturedProductTile.view';
import PropTypes from 'prop-types';
import React from 'react';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { routerPush, getImageFilePath } from '@tcp/core/src/utils';
import Image from '@tcp/core/src/components/common/atoms/Image';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import {
  newSearchBarLabels,
  SEARCH_BAR_LABELS,
  lblSearchProductMatches,
} from '../labels/NewSearchBar.labels';
import style from '../styles/FeaturedProducts.style';

const redirectToSlp = (searchText) => {
  if (searchText) {
    routerPush(
      `/search?searchQuery=${searchText}&searchType=top matching products`,
      `/search/${searchText}`,
      { shallow: true }
    );
  }
};
const FeaturedProducts = (props) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);
  const searchBarLabels = getLabelFromCopyOrFromTranslation(SEARCH_BAR_LABELS, newSearchBarLabels);
  const {
    className,
    featuredProductList,
    redirectToProductUrl,
    onCloseClick,
    isSearchBarAutosuggestProductsEnabled,
    searchInput,
    closeSearchBar,
  } = props;
  const hasMounted = useHasMounted();

  let containerClass = 'featured-products-desktop';
  if (isSearchBarAutosuggestProductsEnabled) {
    containerClass += ' featured-auto-suggest';
  }
  const searchHeader = searchInput?.current?.value
    ? renderLabel(searchBarLabels[lblSearchProductMatches], lblSearchProductMatches)
    : renderLabel(slpLabels?.lbl_featured_products, 'lbl_featured_products');

  const renderProductInfo = () => {
    return featuredProductList.map((productInfo) => (
      <div key={productInfo?.id} data-prodId={productInfo?.prodId} className="product-tile-wrapper">
        <FeaturedProductTile
          {...productInfo}
          redirectToProductUrl={redirectToProductUrl}
          onCloseClick={onCloseClick}
          searchEnhancementRedesign
          searchHeader={searchHeader.toLowerCase()}
        />
      </div>
    ));
  };

  return (
    <div className={`${className} ${containerClass}`}>
      <div className="view-all-heading-wrapper">
        <div className="feature-product-header">{searchHeader}</div>
        {searchInput?.current?.value && (
          <Anchor
            underline
            className="view-all-link"
            anchorVariation="primary"
            tabIndex="0"
            to={(hasMounted && `/search/${searchInput?.current?.value}`) || ''}
            onClick={(e) => {
              e.preventDefault();
              closeSearchBar(e);
              redirectToSlp(`${searchInput?.current?.value}`);
            }}
          >
            {renderLabel(slpLabels?.lbl_view_all, 'lbl_view_all')}
            <Image
              className="view-all-right-arrow"
              src={`${getImageFilePath()}/right-arrow.png`}
              alt="view all right arrow"
            />
          </Anchor>
        )}
      </div>
      <div className="featured-products-grid">{renderProductInfo()}</div>
    </div>
  );
};
FeaturedProducts.propTypes = {
  className: PropTypes.string.isRequired,
  featuredProductList: PropTypes.arrayOf({
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    originalPrice: PropTypes.string,
    offerPrice: PropTypes.string,
    offerText: PropTypes.string,
    productName: PropTypes.string,
    pdpUrl: PropTypes.string,
    ratings: PropTypes.number,
    reviewCount: PropTypes.number,
  }),
  redirectToProductUrl: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  isSearchBarAutosuggestProductsEnabled: PropTypes.bool.isRequired,
};
FeaturedProducts.defaultProps = {
  featuredProductList: [],
};
export { FeaturedProducts as FeaturedProductsVanilla };
export default withStyles(FeaturedProducts, style);
